import { useState } from "react";
import { MdAdd } from "react-icons/md";
import NewDeliveryNote from "../GoodsIssueBooking/NewDeliveryNote";
import "./GoodsOut.scss";

function getCurrentMonthRange() {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();
  const first = new Date(year, month, 1);
  const last = new Date(year, month + 1, 0);
  const format = (date: Date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const monthStr = String(date.getMonth() + 1).padStart(2, "0");
    return `${day}.${monthStr}.${date.getFullYear()}`;
  };
  return `${format(first)} - ${format(last)}`;
}

export default function GoodsOut() {
  const [isDeliveryNoteOpen, setIsDeliveryNoteOpen] = useState(false);
  const [showCompleted, setShowCompleted] = useState(false);
  const [period] = useState(getCurrentMonthRange);
  const [imei, setImei] = useState("");

  function handleReset() {
    setImei("");
    setShowCompleted(false);
  }

  return (
    <section className="sales-layout__page goods-out" aria-labelledby="goods-out-title">
      <div className="goods-out__layout">
        <div className="goods-out__main">
          <div className="goods-out__top-row">
            <header className="goods-out__header">
              <h1 id="goods-out-title">Alle Warenausgänge</h1>
              <p>Übersicht aller ausgehenden Waren und Erstellung neuer Lieferscheine.</p>
            </header>

            <div className="goods-out__primary">
              <button
                type="button"
                className="goods-out__btn-action goods-out__btn-action--primary"
                onClick={() => setIsDeliveryNoteOpen(true)}
              >
                <MdAdd aria-hidden="true" /> Neuer Lieferschein
              </button>
            </div>
          </div>
        </div>

        <aside className="goods-out__filters" aria-labelledby="goods-out-filters-title">
          <h2 id="goods-out-filters-title" className="goods-out__filters-title">
            Filter
          </h2>

          <div className="goods-out__field">
            <label htmlFor="goods-out-period">Lieferscheine für Zeitraum</label>
            <p id="goods-out-period" className="goods-out__period">
              {period}
            </p>
          </div>

          <div className="goods-out__field">
            <label htmlFor="goods-out-imei">Seriennummer / IMEI</label>
            <input
              id="goods-out-imei"
              name="imei"
              type="text"
              inputMode="numeric"
              placeholder="Seriennummer oder IMEI"
              value={imei}
              onChange={(event) => setImei(event.target.value)}
            />
          </div>

          <label className="goods-out__switch">
            <input
              type="checkbox"
              name="showCompleted"
              role="switch"
              checked={showCompleted}
              onChange={(event) => setShowCompleted(event.target.checked)}
            />
            <span className="goods-out__switch-track" aria-hidden="true" />
            <span>Erledigte Aufträge anzeigen</span>
          </label>

          <div className="goods-out__filter-actions">
            <button
              type="button"
              className="goods-out__btn-action goods-out__btn-action--secondary"
            >
              anzeigen
            </button>
            <button
              type="button"
              className="goods-out__btn-action goods-out__btn-action--danger"
              onClick={handleReset}
            >
              Zurücksetzen
            </button>
          </div>
        </aside>
      </div>

      {isDeliveryNoteOpen && <NewDeliveryNote onClose={() => setIsDeliveryNoteOpen(false)} />}
    </section>
  );
}
